import { post, put, get, remove } from 'communication/httpClient';
import {
  LOAD_RETURN_POLICIES,
  RETURN_POLICIES_LOADED,
  SYNC_FAILED,
  RESET_RETURN_POLICIES,
  RESET_RETURN_POLICY,
  RETURN_POLICY_DELETED,
  LOAD_RETURN_POLICY,
  RETURN_POLICY_LOADED,
  SAVE_RETURN_POLICY,
  RETURN_POLICIES_SAVED,
  RETURN_POLICIES_POPUP,
  SYNCING,
  RESET_ERROR,
} from './actionTypes';

export const initialActionsState = {
  loadReturnPolicies: () => {},
  resetReturnPolicies: () => {},
  resetReturnPolicy: () => {},
  deleteReturnPolicy: () => {},
  addReturnPolicy: () => {},
  loadReturnPolicy: (id: string) => {},
  updateReturnPoliciesSavedValue: () => {},
  updateReturnPoliciesPopupOpen: (value: boolean) => {},
  returnPolicyDeleted: (id: string) => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => {
  const loadReturnPolicies = async () => {
    dispatch({
      type: RESET_ERROR,
    });
    dispatch({
      type: LOAD_RETURN_POLICIES,
    });
    const { data, error } = await get('/api/return-policies');
    if (data) {
      dispatch({
        type: RETURN_POLICIES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  };
  return {
    loadReturnPolicies: loadReturnPolicies,
    loadReturnPolicy: async (id: string) => {
      dispatch({
        type: RESET_ERROR,
      });
      dispatch({
        type: LOAD_RETURN_POLICY,
      });
      const { data, error } = await get('/api/return-policies/' + id);

      if (data) {
        dispatch({
          type: RETURN_POLICY_LOADED,
          payload: data,
        });
      } else {
        dispatch({
          type: SYNC_FAILED,
          payload: error,
        });
      }
    },
    resetReturnPolicies: () =>
      dispatch({
        type: RESET_RETURN_POLICIES,
      }),
    resetReturnPolicy: () =>
      dispatch({
        type: RESET_RETURN_POLICY,
      }),
    deleteReturnPolicy: async (ruleId: string, callback?: () => void) => {
      dispatch({
        type: SYNCING,
      });
      const { data, error } = await remove('/api/return-policies/' + ruleId);
      if (data || data === '') {
        dispatch({
          type: RETURN_POLICY_DELETED,
          payload: ruleId,
        });
        if (callback) {
          callback();
        }
      } else {
        dispatch({
          type: SYNC_FAILED,
          payload: error,
        });
      }
    },
    addReturnPolicy: async (values: any, id?: string, callback?: (newId: string) => void) => {
      dispatch({
        type: SAVE_RETURN_POLICY,
      });
      const handler = id ? put : post,
        resourceId = id ? `/${id}` : '';
      const { data, error } = await handler('/api/return-policies' + resourceId, values);

      if (data || data === '') {
        await loadReturnPolicies();
        dispatch({
          type: RETURN_POLICIES_SAVED,
        });
        if (callback) {
          callback(data.id);
        }
      } else {
        dispatch({
          type: SYNC_FAILED,
          payload: error,
        });
      }
    },
    updateReturnPoliciesSavedValue: () => {
      dispatch({
        type: RETURN_POLICIES_SAVED,
      });
    },
    updateReturnPoliciesPopupOpen: (value) => {
      dispatch({
        type: RETURN_POLICIES_POPUP,
        payload: value,
      });
    },
    returnPolicyDeleted: (id) => {
      dispatch({
        type: RETURN_POLICY_DELETED,
        payload: id,
      });
    },
    resetError: () => {
      dispatch({
        type: RESET_ERROR,
      });
    },
  };
};
